import React from "react";

/**
 * Shared section wrapper used across admin screens (Settings, Vendor Onboarding,
 * Chatbot Users, Profile, ...) so every "card" on the dashboard shares the same
 * spacing, radius, shadow and header treatment.
 */
const SectionCard = ({ title, description, icon, actions, extra = "", children }) => (
  <section
    className={`w-full rounded-2xl bg-white p-6 shadow-lg shadow-gray-200/60 dark:bg-navy-800 dark:shadow-none ${extra}`}
  >
    {(title || description || icon || actions) && (
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-3">
          {icon ? (
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-xl text-brand-500 dark:bg-navy-700 dark:text-white">
              {icon}
            </span>
          ) : null}
          <div>
            {title ? (
              <h2 className="text-xl font-bold text-navy-700 dark:text-white">{title}</h2>
            ) : null}
            {description ? (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
            ) : null}
          </div>
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    )}
    {children}
  </section>
);

export default SectionCard;
